export type IconKey = keyof typeof icons; // "close" | "delete" | ...
export type IconClass = (typeof icons)[IconKey]; // "fas fa-times" | "fas fa-trash" | ...

//const icons = {
export const icons = {
  // General actions
  add: "fas fa-plus",
  cancel: "fas fa-ban",
  check: "fas fa-check",
  checkCircle: "fas fa-circle-check",
  close: "fas fa-times",
  delete: "fas fa-trash",
  download: "fas fa-download",
  edit: "fas fa-edit",
  error: "fas fa-exclamation-circle",
  info: "fas fa-info-circle",
  paperPlaneOutline: "far fa-paper-plane",
  refresh: "fas fa-sync-alt",
  save: "fas fa-save",
  search: "fas fa-search",
  uncheckedCircle: "far fa-circle",
  upload: "fas fa-upload",
  warning: "fas fa-exclamation-triangle",
  clone: "fas fa-clone",
  comment: "fas fa-comment",
  commentFilled: "fas fa-comment-dots",
  eye: "fas fa-eye",

  // Navigation
  home: "fas fa-home",
  lock: "fas fa-lock",
  menu: "fas fa-bars",
  settings: "fas fa-cog",
  unlock: "fas fa-unlock",
  user: "fas fa-user",

  // Media / files
  file: "fas fa-file",
  file_csv: "fas fa-file-csv",
  folder: "fas fa-folder",
  image: "fas fa-image",
  pause: "fas fa-pause",
  play: "fas fa-play",
  screenCollapse: "fas fa-compress",
  screenExpand: "fas fa-expand",
  stop: "fas fa-stop",
  video: "fas fa-video",
  envelope: "fas fa-envelope",

  // Arrows
  down: "fas fa-angle-down",
  left: "fas fa-angle-left",
  right: "fas fa-angle-right",
  up: "fas fa-angle-up",

  // Template Elements
  checkBoxList: "fas fa-tasks",
  checkbox: "fas fa-square-check",
  dataSelect: "fas fa-database",
  grade: "fas fa-award",
  section: "far fa-square-full",
  selectField: "far fa-square-caret-down",
  radioField: "far fa-circle-dot",
  selectProgram: "fas fa-book",
  table: "fas fa-table",
  textArea: "fas fa-bars",
  textField: "fas fa-i-cursor",
  banner: "fa-circle-info",

  //formatting
  alignCenter: "fas fa-align-center",
  alignLeft: "fas fa-align-left",
  alignRight: "fas fa-align-right",
  bold: "fas fa-bold",
  clean: "fas fa-broom",
  clear: "fas fa-ban",
  indent: "fas fa-indent",
  italic: "fas fa-italic",
  link: "fas fa-link",
  orderedList: "fas fa-list-ol",
  outdent: "fas fa-outdent",
  redo: "fas fa-redo",
  underline: "fas fa-underline",
  undo: "fas fa-undo",
  unlink: "fas fa-unlink",
  unorderedList: "fas fa-list-ul",

  //misc
  more: "fas fa-ellipsis",
  unchecked: "far fa-square",
  filter: "fa fa-filter"
};

export const iconKeys = Object.keys(icons) as IconKey[];

export default icons;
